import { useHubble } from '@seek/hubble';
import {
  type ActivityType,
  addTags,
  type PageName,
  type SolMetadata,
} from '@seek/sol-js';
import { useEffect, useMemo, useState } from 'react';

import { useAppConfig } from 'src/components/App/useAppConfig';

const useHubbleTrackActivity = ({
  trackType,
  solMetadata,
  page,
  topApplicantBadgeShown,
  linkout,
  isSalaryMatch,
  isAddSalaryPrefNudgeShown,
}: {
  trackType: ActivityType;
  solMetadata: SolMetadata;
  page: PageName;
  topApplicantBadgeShown: boolean;
  linkout: boolean;
  isSalaryMatch: boolean;
  isAddSalaryPrefNudgeShown: boolean;
}) => {
  const { environment } = useAppConfig();
  const [tracked, setTracked] = useState(false);
  const hubble = useHubble();

  const enhancedSolMetaData = useMemo(
    () =>
      addTags(solMetadata, {
        // TODO: we will need to revisit below tag if we decide to auto select the first job
        // Expected values for this tag is summarised in this page:
        // https://myseek.atlassian.net/wiki/spaces/AJDT/pages/2433746322/Job+Details+Viewed+Hubble+Tracking
        'sol:eventTrigger': 'default',
        // End of tag to revisit
      }),
    [solMetadata],
  );

  useEffect(() => {
    if (enhancedSolMetaData && !tracked) {
      setTracked(true);

      hubble.trackEvent('job_details_displayed', {
        applicationTipsType: 'NotShown',
        jobId: enhancedSolMetaData.jobId,
        topApplicantBadgeShown,
        solMetadata: enhancedSolMetaData,
        linkout,
        currentPage: page,
        isSalaryMatch,
        isAddSalaryPrefNudgeShown,
      });
    }
  }, [
    enhancedSolMetaData,
    environment,
    trackType,
    page,
    setTracked,
    tracked,
    hubble,
    topApplicantBadgeShown,
    linkout,
    isSalaryMatch,
    isAddSalaryPrefNudgeShown,
  ]);
};

export default useHubbleTrackActivity;
